;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="d0709902-35ef-4cd3-abec-bdcb75c92678",e._sentryDebugIdIdentifier="sentry-dbid-d0709902-35ef-4cd3-abec-bdcb75c92678")}catch(e){}}();import classNames from '../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import React__default from 'react';
import styles from './Link.module.scss.js';
import '../../_virtual/_sentry-release-injection-file.js';

var LinkTypeEnum;
(function (LinkTypeEnum) {
    LinkTypeEnum["OFFER"] = "offer";
    LinkTypeEnum["PRIMARY"] = "primary";
    LinkTypeEnum["NEUTRAL"] = "neutral";
})(LinkTypeEnum || (LinkTypeEnum = {}));
const Link = ({ children, bold = true, heading, ellipsis, noWrap, linkType = LinkTypeEnum.PRIMARY, withPadding = true, href, dataZta, className, ...props }) => {
    return (React__default.createElement("a", { href: href, "data-zta": dataZta, "data-link-type": linkType, className: classNames(className, styles.link, {
            [styles.linkPadding]: withPadding,
            [styles.linkNoWrap]: noWrap,
            [styles.linkEllipsis]: ellipsis,
            [styles.linkBold]: bold,
            [styles.linkHeading]: heading,
            [styles.linkPrimary]: linkType === LinkTypeEnum.PRIMARY,
            [styles.linkOffer]: linkType === LinkTypeEnum.OFFER,
            [styles.linkNeutral]: linkType === LinkTypeEnum.NEUTRAL,
        }), ...props }, children));
};

export { LinkTypeEnum, Link as default };
//# sourceMappingURL=Link.js.map
